export default import.meta.ROLLUP_FILE_URL_2F$EJ$OeZrhpFK8bIWAuRw